import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';

// Re-export MatRadioModule so consumers can use mat-radio-group
export { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'pbb-radio',
  standalone: true,
  imports: [CommonModule, MatRadioModule],
  templateUrl: './pbb-radio.component.html',
  styleUrls: ['./pbb-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PbbRadioComponent),
      multi: true,
    },
  ],
})
export class PbbRadioComponent implements ControlValueAccessor {
  @Input() id?: string;
  @Input() name?: string;
  @Input() value?: any;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() disabled = false;
  @Input() checked = false;
  @Input() labelPosition: 'before' | 'after' = 'after';
  @Input() ariaLabel?: string;
  @Input() ariaLabelledby?: string;
  @Input() ariaDescribedby?: string;
  @Input() cssClass: string = '';

  @Output() selectionChange = new EventEmitter<MatRadioChange>();
  @Output() clicked = new EventEmitter<null>();

  // ControlValueAccessor implementation
  private onChange = (value: any) => {};
  private onTouched = () => {};

  onRadioChange(event: MatRadioChange): void {
    if (!event) {
      return;
    }
    this.checked = event.source.checked;
    this.onChange(event.value);
    this.onTouched();
    this.selectionChange.emit(event);
  }

  radioClicked(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) this.clicked.emit();
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.checked = value === this.value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
